import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SingleTabService {
  private readonly channel = new BroadcastChannel('single-tab-control');
  private isMainTab = false;
  private gotResponse = false;
  private readonly instanceId = Math.random().toString(36).substring(2);
  public block$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.channel.onmessage = (event) => {
      const { type, from } = event.data;

      if (type === 'check-active') {
        // Otra pestaña pregunta si hay una activa → responde si tú lo eres
        if (this.isMainTab) {
          this.channel.postMessage({ type: 'active-tab-exists', from: this.instanceId });
        }
      } else if (type === 'active-tab-exists' && from !== this.instanceId) {
        // Se recibió confirmación de otra pestaña activa
        this.gotResponse = true;
        this.block$.next(true);
      }
    };

    this.checkIfOtherTabIsActive();
    window.addEventListener('beforeunload', () => this.cleanup());
  }

  private checkIfOtherTabIsActive() {
    // Pregunta si hay otra pestaña activa
    this.channel.postMessage({ type: 'check-active', from: this.instanceId });

    // Espera un corto tiempo a que alguien responda
    setTimeout(() => {
      if (!this.gotResponse) {
        this.isMainTab = true;
        this.block$.next(false);
        console.log('[SingleTab] Esta es la única pestaña activa.');
      } else {
        console.log('[SingleTab] Otra pestaña ya está activa.');
      }
    }, 500);
  }

  private cleanup() {
    this.channel.close();
  }
}
